import {
	IonButton,
	IonButtons,
	IonCardContent,
	IonCol,
	IonContent,
	IonDatetime,
	IonGrid,
	IonHeader,
	IonInput,
	IonItem,
	IonLabel,
	IonMenuButton,
	IonModal,
	IonPage,
	IonRow,
	IonTitle,
	IonToolbar
} from "@ionic/react";

import BarChart from "../components/BarChart";
import DoughnutChart from "../components/DoughnutChart";
import DashboardCards from "../components/DashboardCards";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Date } from "../controls";
import moment from "moment";

const Home: React.FC = () => {
	const { t } = useTranslation();
	const [from, setFrom] = useState<string>(
		moment().startOf("month").format("YYYY-MM-DDTHH:mm:ssZ")
	);
	const [to, setTo] = useState<string>(
		moment().endOf("month").format("YYYY-MM-DDTHH:mm:ssZ")
	);

	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonButtons slot="start">
						<IonMenuButton />
					</IonButtons>
					<IonTitle>{t("dashboard")}</IonTitle>
				</IonToolbar>
			</IonHeader>

			<IonContent fullscreen>
				<IonHeader collapse="condense">
					<IonToolbar>
						<IonTitle size="large">{t("dashboard")}</IonTitle>
					</IonToolbar>
				</IonHeader>

				<IonGrid>
					<IonRow>
						<IonCol size="6">
							<Date
								id="from"
								label={t("from")}
								value={from}
								onChange={(e: any) => setFrom(e.target.value)}
							/>
						</IonCol>
						<IonCol size="6">
							<Date
								id="to"
								label={t("to")}
								value={to}
								onChange={(e: any) => setTo(e.target.value)}
							/>
						</IonCol>
						<DashboardCards from={from} to={to} />
						<BarChart />
						<DoughnutChart />
					</IonRow>
				</IonGrid>
			</IonContent>
		</IonPage>
	);
};

export default Home;
